import Index from './index.vue'

export default [
  {
    path: '/newOrganization',
    name: 'newOrganization',
    component: Index,
    title: 'New Organization',
    children: [],
  },
]
